import { render, staticRenderFns } from "./rpt-assigned.vue?vue&type=template&id=5d5c2cbb&"
import script from "./rpt-assigned.js?vue&type=script&lang=js&"
export * from "./rpt-assigned.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports